import { graphql } from "gatsby";
import React from "react";
import { Link } from "../atoms/link";
import Image from "../atoms/image";
import classNames from "classnames";
import Icon from "../atoms/icon";

export const sortBoxes = (a, b) => {
  const posA = parseInt(a?.hooverStPosition?.position[0]);
  const posB = parseInt(b?.hooverStPosition?.position[0]);
  return !isNaN(posA) && !isNaN(posB)
    ? posA - posB
    : isNaN(posA) && isNaN(posB)
    ? 0
    : isNaN(posA)
    ? 1
    : -1;
};

const ProductAppBooklet = ({ app }) => {
  return (
    <>
      <div className="libretto-product-app">
        <div className="app-logo">
          <Image
            objectPosition={`${app.logoImage.focuslr?.[0] || "center"} ${
              app.logoImage.focustb?.[0] || "center"
            }`}
            image={app.logoImage.image}
            alt={app.logoImage.image.value?.description || ""}
          />
        </div>
        <div className="app-title">
          <span>{app.title}</span>
        </div>
        <div className="app-text">
          <span
            dangerouslySetInnerHTML={{
              __html: app.descriptionBooklet,
            }}
          ></span>
        </div>
        <div className="app-buttons">
          {app.appStoreIcon.sort(sortBoxes).map((badge, i) => (
            <Link to={badge.linkApp} target={badge.target} key={i}>
              <Image image={badge.imageIcon} alt={badge.imageIcon.value?.description || ""} />
            </Link>
          ))}
        </div>
        <div className="app-link">
          <Link to={app.cta.link} target={app.cta.target}>
            {app.cta.label}
            {app.cta.label && <Icon name="symbols-arrow-right" />}
          </Link>
        </div>
      </div>
      {app?.bookletImage?.bookletImage && (
        <div className="libretto-product-smart">
          <div className="libretto-red-bg"></div>
          <div className="smartphone-with-mock">
            <div className="smartphone-mock">
              <Image
                objectPosition={"center center"}
                image={app.bookletImage.bookletImage}
                alt={app.bookletImage.bookletImage?.value?.description || ""}
              />
            </div>
            <div className="smartphone-animation">
              <video autoPlay loop muted>
                <source src={app.bookletImage.video} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const ProductApp = ({ app, showMobile, position }) => {
  return app.origin === "booklet" || position === "booklet" ? (
    <ProductAppBooklet app={app} />
  ) : position === "pcb" ? (
    <>
      <div id="app-libretto" className="libretto-app-container">
        <ProductAppBooklet app={app} />
      </div>
    </>
  ) : (
    <div className={classNames("productApp", showMobile && "mobile")}>
      <div className="productApp__row">
        <div className="productApp__colSx">
          <div className="productApp__logo">
            <Image
              objectPosition={`${app.logoImage.focuslr?.[0] || "center"} ${
                app.logoImage.focustb?.[0] || "center"
              }`}
              image={app.logoImage.image}
              alt={app.logoImage.image.value?.description || ""}
            />
          </div>
        </div>
        <div className="productApp__colDx">
          <div
            className="productApp__text"
            dangerouslySetInnerHTML={{
              __html: app.descriptionPdp,
            }}
          ></div>
          <div className="productApp__buttons">
            {app.appStoreIcon.sort(sortBoxes).map((badge, i) => (
              <div className="productApp__button" key={i}>
                <Link to={badge.linkApp} target={badge.target}>
                  <Image image={badge.imageIcon} alt={badge.imageIcon.value?.description || ""} />
                </Link>
              </div>
            ))}
          </div>
          <div className="productApp__link">
            <Link to={app.cta.link} target={app.cta.target}>
              {app.cta.label}
              {app.cta.label && <Icon name="symbols-arrow-right" />}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductApp;

export const fragment = graphql`
  fragment ProductAppAppFragment on LiferayProductAppApp {
    title
    descriptionPdp
    descriptionBooklet
    idOption
    idAttribute
    hooverStMultipleLines {
      multipleLines
    }
    logoImage {
      focustb
      focuslr
      image {
        node {
          publicURL
          gatsbyImageData
        }
        value {
          description
        }
      }
    }
    bookletImage {
      bookletImage {
        node {
          publicURL
          gatsbyImageData
        }
        value {
          description
        }
      }
      video
    }
    appStoreIcon {
      linkApp
      hooverStPosition {
        position
      }
      imageIcon {
        node {
          publicURL
          gatsbyImageData(width: 110, layout: CONSTRAINED)
        }
        value {
          description
        }
      }
    }
    cta {
      ...ButtonFragment
    }
  }
  fragment ProductAppFragment on LiferayProductApp {
    app {
      ...ProductAppAppFragment
    }
  }
`;
